import React from "react";
import { formatPhoneNumber } from "@/lib/utils";
import { CANCEL_REASONS, LOST_LEAD_REASONS, MOVE_STATUSES } from "@/constants";
import { Move } from "@/types";
import Links from "./components/Links";

const STATUS_COLORS = {
  initial: "bg-green-500",
  contacting: "bg-yellow-500",
  quoted: "bg-amber-600",
  booked: "bg-blue-500",
  in_progress: "bg-orange-500",
  completed: "bg-green-500",
  lost: "bg-black",
  canceled: "bg-red-500",
  expired: "bg-gray-500",
};

interface HeaderProps {
  move: Move;
}

const Header: React.FC<HeaderProps> = ({ move }) => {
  return (
    <div className="pb-4">
      <div className="flex flex-col gap-4">
        <div
          className={`${
            STATUS_COLORS[move.status as keyof typeof STATUS_COLORS]
          } flex flex-col gap-0.5 px-2 py-2 text-white text-sm font-medium -mx-4 text-center`}
        >
          <span className="uppercase">
            {MOVE_STATUSES[move.status as keyof typeof MOVE_STATUSES] || "-"}
          </span>
          {move.status === "lost" && move.status_info && (
            <span className="text-sm font-normal lowercase">
              (
              {LOST_LEAD_REASONS[
                move.status_info as keyof typeof LOST_LEAD_REASONS
              ] || "-"}
              )
            </span>
          )}
          {move.status === "canceled" && move.status_info && (
            <span className="text-sm font-normal lowercase">
              (
              {CANCEL_REASONS[
                move.status_info as keyof typeof CANCEL_REASONS
              ] || "-"}
              )
            </span>
          )}
        </div>
        <div className="flex items-center justify-start gap-4 mb-0">
          <div className="flex flex-col items-start justify-start gap-1">
            <p className="text-sm font-medium text-stone-800">
              JOB #{move.number}
            </p>
            <div>
              <h1 className="text-2xl font-semibold">{move.customer_name}</h1>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          {move.customer_mobile_phone && (
            <div className="flex space-x-2 items-center">
              {/* <SmartphoneIcon className="w-4 h-4" /> */}
              <a
                className="text-sm link"
                href={`tel:${move.customer_mobile_phone}`}
              >
                {formatPhoneNumber(move.customer_mobile_phone)}
              </a>
            </div>
          )}
          {move.customer_alternate_phone && (
            <div className="flex space-x-2 items-center">
              {/* <PhoneIcon className="w-4 h-4" /> */}
              <a
                className="text-sm link"
                href={`tel:${move.customer_alternate_phone}`}
              >
                {formatPhoneNumber(move.customer_alternate_phone)}
              </a>
            </div>
          )}
          {move.customer_email && (
            <div className="flex space-x-2 items-center w-full overflow-hidden">
              {/* <MailPlusIcon className="w-4 h-4" /> */}
              <a
                className="text-sm link break-words overflow-wrap-anywhere w-full"
                href={`mailto:${move.customer_email}`}
              >
                {move.customer_email}
              </a>
            </div>
          )}
        </div>
        <div className="mt-4">
          <Links move={move} />
        </div>

        <div className="mt-4 flex flex-col gap-3">
          <div className="flex flex-col gap-0.5">
            <span className="text-xs uppercase font-normal text-stone-600">
              Sales Owner
            </span>
            <span className="text-sm font-normal">
              {move.sales_owner?.name || "-"}
            </span>
          </div>

          <div className="flex flex-col gap-0.5">
            <span className="text-xs uppercase font-normal text-stone-600">
              Source
            </span>
            <span className="text-sm font-normal">
              {move.customer_source || "-"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
